<list-view *ngIf="listeExternes" [liste]="listeExternes"></list-view>
<floating-button [listeActions]="listeActions" [isPending]="isPending"></floating-button>
